import { useParams } from "@tanstack/react-router";
import { t } from "i18next";
import { MessageSquareText } from "lucide-react";
import type { JSX } from "react";
import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { useSidebar } from "@/components/ui/sidebar/useSidebar";
import { useFeedbackStore } from "@/store/feedback.store";

interface Props {
  className?: string;
  // Label as a tooltip (icon rail).
  tooltip?: boolean;
}

// App menu entry for "Send feedback". On a visit page the dialog offers to
// include that visit's id.
export const FeedbackMenuItem = ({
  className,
  tooltip = false,
}: Props): JSX.Element => {
  const params = useParams({ strict: false }) as { visitPublicId?: string };
  const { isMobile, setOpenMobile } = useSidebar();
  const label = t("sidebar.sendFeedback");

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        className={className}
        data-testid="send-feedback-menu"
        tooltip={tooltip ? label : undefined}
        type="button"
        onClick={() => {
          // Phones: close the menu drawer so the sheet is not under it.
          if (isMobile) setOpenMobile(false);
          useFeedbackStore
            .getState()
            .show({ visitPublicId: params.visitPublicId ?? null });
        }}
      >
        <MessageSquareText aria-hidden="true" className="w-auto! h-6!" />
        <span>{label}</span>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
